export default "/pt-ezeth.9b3d5e7a19b83f594d29bdfcc5fbcc50.svg";